import { notification } from 'antd'

class Notification {
  constructor(library) {
    this.notification = library
  }

  error(message, description = '') {
    this.notification.error({ message, description })
  }

  warning(message, description = '') {
    this.notification.warning({ message, description })
  }

  success(message, description = '') {
    this.notification.success({ message, description })
  }
}

const library = notification

export default new Notification(library)
